import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { initializeAuth } from "../../redux/action/actions";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import ScrollTop from "../ScrollTop";
import ToastManager from "../ToastManager/ToastManager";

const PublicLayout = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        // Initialize authentication state from localStorage (optional for public pages)
        dispatch(initializeAuth());
    }, [dispatch]);

    return (
        <div className="min-h-screen min-w-screen flex flex-col">
            <ScrollTop />
            <ToastManager />
            <Header />
            <main className="flex-grow">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};

export default PublicLayout; 